import { AvailedSummaryLeave, AvailedLeaveUserDetails, CreateBulk } from "../Components/index.js";

export default [
    {
        path: "/ration-return/availed-summary-leave",
        component: AvailedSummaryLeave,
        name: "ration-return-availed-summary-leave",
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/ration-return/availed-leave-user-details/:id",
        component: AvailedLeaveUserDetails,
        name: "ration-return-availed-leave-user-details",
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/ration-return/availed-leave-user-add/:id",
        component: CreateBulk,
        name: "ration-return-availed-leave-user-add",
        meta: {
            requiresAuth: true,
        },
    },
];
